export const formatDate = (date, noTime) => {
    let baseDate = [
      formatDateElement(date.getFullYear()),
      formatDateElement(date.getMonth()+1),
      formatDateElement(date.getDate()),
      
                  ].join('-')
    let time = [formatDateElement(date.getHours()),
      formatDateElement(date.getMinutes()),
      formatDateElement(date.getSeconds())].join(':');
    if(noTime){
      return baseDate
    }
    return baseDate + ' ' + time
    
   
}

export const formatDateElement = (el) => {
  if(el < 10) return '0'+el
  else return el
}